export default "__VITE_ASSET__uTYn73$b__"